import http from '../utils/http-common';

const getLawtalkNumber = () => {
  return http.axiosCreate.get(`/number`, { timeout: 2500 });
};

export default {
  getLawtalkNumber,
};
